// ========================================
// ========== Global Plugins ==============
// ========================================

import Vue from "vue";
import Router from "vue-router";
// import * as Plugins from "@/plugins";
import PortalVue from "portal-vue";
import VueShowdown from 'vue-showdown';
import CompositionAPI from "@vue/composition-api";
import { UIPlugin } from "@ui";
import { LangPlugin } from "@lang";


Vue.use(UIPlugin);
Vue.use(Router);
Vue.use(LangPlugin);
Vue.use(CompositionAPI);
Vue.use(PortalVue);
Vue.use(VueShowdown)

// ========================================
// ============== App Init ================
// ========================================

import { router } from '@/router';
import { store } from "@/store";
// import { i18n } from "@/i18n";
import App from "./App.vue";

new Vue({
	el: "#app",
	router,
	store,
	// i18n,
	components: { App },
	template: "<App/>"
});